<template>

  <form id="activeForm" class="mx-auto col-sm-12" @submit.prevent>

    <div class="row mb-3" v-show="active.registerType === 'BATCH' && active.activeType">
      <div class="col-lg-12">
        <h3>Último serial cadastrado: {{ lastSerial }}</h3>
      </div>
    </div>

    <div class="row">
      <div class="form-group col-lg-6">
        <label for="register_type">{{ $t('register_type') }}</label>
        <Combobox
          :disabled="isEdit"
          class="bg-white"
          name='register_type'
          :hasErrors="errors.has('register_type')"
          :placeholder="$t('select_a_item')"
          label="label"
          :options="[{ label: 'INDIVIDUAL', value: 'INDIVIDUAL' }, { label: 'EM LOTE', value: 'BATCH' } ]"
          :initial-value="active.registerType"
          v-model="active.registerType"
          :reduce="active => active.value"
          v-validate="'required'"
        />

        <small v-show="errors.has('register_type')" class="form-text">
          {{ errors.first('register_type') }}
        </small>
      </div>

      <div class="form-group col-lg-6" v-show="active.registerType === 'BATCH' && !isEdit">
        <label for="generate_serial">{{ $t('generate_serial') }}</label>
        <Combobox
          :disabled="isEdit"
          class="bg-white"
          name='generate_serial'
          :hasErrors="errors.has('generate_serial')"
          :placeholder="$t('select_a_item')"
          label="label"
          :options="[{ label: 'AUTOMÁTICO', value: 'AUTO' }, { label: 'MANUAL', value: 'MANUAL' }]"
          :initial-value="active.generateSerial"
          v-model="active.generateSerial"
          :reduce="generateType => generateType.value"
          v-validate="`${validateGenerateSerial}`"
        />

        <small v-show="errors.has('generate_serial')" class="form-text">
          {{ errors.first('generate_serial') }}
        </small>
      </div>
    </div>

    <div class="row">
      <div class="form-group col-lg-4">
        <label for="active_type">{{ $t('active_type') }}</label>
        <Combobox
          class="bg-white"
          :hasErrors="errors.has('active_type')"
          name='active_type'
          :placeholder="$t('select_a_item')"
          label="name"
          :options="activestypes"
          :initial-value="active.activeType"
          v-model="active.activeType"
          :reduce="activesTypes => activesTypes.id"
          v-validate="'required'"
        />

        <small v-show="errors.has('active_type')" class="form-text">
          {{ errors.first('active_type') }}
        </small>
      </div>

      <div class="form-group col-lg-4" :class="{ 'has-error': errors.has('prefix') }">
        <label for="prefix">{{ $t('prefix') }}</label>
        <input
          disabled
          type="text"
          id="prefix"
          name="prefix"
          class="form-control"
          :placeholder="$t('ph_prefix')"
          v-model="active.prefix"
          @input="upper('prefix')"
        >

        <small v-show="errors.has('prefix')" class="form-text">
          {{ errors.first('prefix') }}
        </small>
      </div>

      <div class="form-group col-lg-4">
        <label for="model">{{ $t('model') }}</label>
        <Combobox
          class="bg-white"
          name='model'
          :disabled="!active.activeType"
          :hasErrors="errors.has('model')"
          :placeholder="$t('select_a_item')"
          label="name"
          :options="models"
          :getOptionLabel="model => model.name ? model.manufacturer.name + ' / ' + model.name : ''"
          :initial-value="active.model"
          v-model="active.model"
          :reduce="models => models.id"
          v-validate="'required'"
        />

        <small v-show="errors.has('model')" class="form-text">
          {{ errors.first('model') }}
        </small>
      </div>
    </div>

    <div class="row">
      <div class="form-group col-lg-4" :class="{ 'has-error': errors.has(legend1.field) }" v-show="active.activeType && legend1.show">
        <label for="field_extra1">{{ $t(legend1.field) }}</label>
        <input
          type="text"
          id="field_extra1"
          name="field_extra1"
          class="form-control"
          :placeholder="$t(legend1.field)"
          v-model="active.fieldExtra1"
          @input="upper('fieldExtra1')"
        >
      </div>

      <div class="form-group col-lg-4" :class="{ 'has-error': errors.has(legend2.field) }" v-show="active.activeType && legend2.show">
        <label for="field_extra2">{{ $t(legend2.field) }}</label>
        <input
          type="text"
          id="field_extra2"
          name="field_extra2"
          class="form-control"
          :placeholder="$t(legend2.field)"
          v-model="active.fieldExtra2"
          @input="upper('fieldExtra2')"
        >
      </div>

      <div class="form-group col-lg-4" :class="{ 'has-error': errors.has(legend3.field) }" v-show="active.activeType && legend3.show">
        <label for="field_extra3">{{ $t(legend3.field) }}</label>
        <input
          type="text"
          id="field_extra3"
          name="field_extra3"
          class="form-control"
          :placeholder="$t(legend3.field)"
          v-model="active.fieldExtra3"
          @input="upper('fieldExtra3')"
        >
      </div>
    </div>

    <div class="row">
      <div class="form-group col-lg-4" :class="{ 'has-error': errors.has('amount_items') }" v-show="active.registerType === 'BATCH' && !isEdit">
        <label for="amount_items">{{ $t('amount_items') }}</label>
        <input
          type="number"
          id="amount_items"
          name="amount_items"
          class="form-control"
          :placeholder="$t('ph_amount_items')"
          v-model="active.amountItems"
          v-validate="`${validateAmountItems}`"
        >

        <small v-show="errors.has('amount_items')" class="form-text">
          {{ errors.first('amount_items') }}
        </small>
      </div>

      <div class="form-group col-lg-4" :class="{ 'has-error': errors.has('from') }" v-show="active.registerType === 'BATCH' && !isEdit">
        <label for="from">{{ $t('from') }}</label>
        <input
          :disabled="active.generateSerial === 'AUTO'"
          type="number"
          id="from"
          name="from"
          class="form-control"
          :placeholder="$t('from')"
          v-model="active.from"
        >

        <small v-show="errors.has('from')" class="form-text">
          {{ errors.first('from') }}
        </small>
      </div>

      <div class="form-group col-lg-4" :class="{ 'has-error': errors.has('until') }" v-show="active.registerType === 'BATCH' && !isEdit">
        <label for="until">{{ $t('until') }}</label>
        <input
          disabled
          type="number"
          id="until"
          name="until"
          class="form-control"
          :placeholder="$t('until')"
          v-model="active.until"
        >
      </div>
    </div>

    <div class="row">
      <div class="form-group col-lg-4" :class="{ 'has-error': errors.has('serie') }">
        <label for="serie">{{ $t('serie') }}</label>
          <input
            :disabled="active.registerType === 'BATCH'"
            type="text"
            id="serie"
            name="serie"
            class="form-control"
            :placeholder="$t('ph_serie')"
            v-model="active.serie"
            v-validate="'required'"
            @input="upper('serie')"
          >

          <small v-show="errors.has('serie')" class="form-text">
            {{ errors.first('serie') }}
          </small>
      </div>

      <div class="form-group col-lg-4">
        <label for="location">{{ $t('location') }}</label>
        <Combobox
          disabled
          class="bg-white"
          name='location'
          :hasErrors="errors.has('location')"
          :placeholder="$t('select_a_item')"
          label="name"
          :options="locations"
          :initial-value="active.location"
          v-model="active.location"
          v-validate="'required'"
        />

        <small v-show="errors.has('location')" class="form-text">
          {{ errors.first('location') }}
        </small>
      </div>

      <div class="form-group col-lg-4">
        <label for="status">{{ $t('status') }}</label>
        <Combobox
          disabled
          class="bg-white"
          name='status'
          :hasErrors="errors.has('status')"
          :placeholder="$t('select_a_item')"
          label="name"
          :options="activeStatus"
          :getOptionLabel="status => status.status ? status.status.name : ''"
          :initial-value="active.status"
          v-model="active.status"
          :reduce="activeStatus => activeStatus.id"
        />

        <small v-show="errors.has('status')" class="form-text">
          {{ errors.first('status') }}
        </small>
      </div>
    </div>

    <div class="row" v-show="isEdit">
      <div class="form-group col-lg-12">
        <label for="garage_accredited">{{ $t('garage_accredited') }}</label>
          <Combobox
            :disabled="active.location !== 'OFICINA CREDENCIADA'"
            class="bg-white"
            name='garage_accredited'
            :hasErrors="errors.has('garage_accredited')"
            :placeholder="$t('select_a_item')"
            label="fantasyName"
            :options="garages"
            :initial-value="active.garageAccredited"
            :reduce="garage => garage.id"
            v-model="active.garageAccredited"
            v-validate="`${validateGarage}`"
          />

          <small v-show="errors.has('garage_accredited')" class="form-text">
            {{ errors.first('garage_accredited') }}
          </small>
      </div>
    </div>

    <div class="row">
      <div class="form-group col-lg-4" :class="{ 'has-error': errors.has('purchase_date') }">
        <label for="purchase_date">{{ $t('purchase_date') }}</label>
        <input
          type="date"
          id="purchase_date"
          name="purchase_date"
          class="form-control"
          v-model="active.purchaseDate"
        />
        <small v-show="errors.has('purchase_date')" class="form-text text-muted">
          {{ errors.first('purchase_date') }}
        </small>
      </div>

      <div class="form-group col-lg-4" :class="{ 'has-error': errors.has('purchase_value') }">
        <label for="purchase_value">{{ $t('purchase_value') }} (unitário)</label>
        <CurrencyInput
          v-model="active.purchaseValue"
          :auto-decimal-mode="true"
          :distraction-free='false'
          currency='BRL'
          locale='pt-BR'
          class="demo__currency-input form-control"
        />

        <small v-show="errors.has('purchase_value')" class="form-text text-muted">
          {{ errors.first('purchase_value') }}
        </small>
      </div>

      <div class="form-group col-lg-4" :class="{ 'has-error': errors.has('warranty_date') }">
        <label for="warranty_date">{{ $t('warranty_date') }}</label>
        <input
          type="date"
          id="warranty_date"
          name="warranty_date"
          class="form-control"
          v-model="active.warrantyDate"
        />
        <small v-show="errors.has('warranty_date')" class="form-text text-muted">
          {{ errors.first('warranty_date') }}
        </small>
      </div>
    </div>

    <div class="form-group">
      <label for="obs">{{ $t('obs') }}</label>
        <textarea
          type="text"
          id="obs"
          name="obs"
          class="form-control"
          :placeholder="$t('ph_obs')"
          v-model="active.obs"
          @input="upper('obs')"
        />
    </div>

    <div class="row">
      <div class="col-lg-6">
        <div class="switch mb-3">
          <label for="isActive">{{ $t('active') }}</label>
          <div class="onoffswitch2">
            <input
              type="checkbox"
              class="onoffswitch2-checkbox"
              id="isActive"
              v-model="active.isActive">
            <label class="onoffswitch2-label" for="isActive">
                <span class="onoffswitch2-inner"></span>
                <span class="onoffswitch2-switch"></span>
            </label>
          </div>
        </div>
      </div>

      <div class="col-lg-6" v-if="active.activeType === 6 && $route.params.id">
        <label for="np">{{ $t('NP') }}</label>
        <div class="onoffswitch2">
          <input
            type="checkbox"
            class="onoffswitch2-checkbox"
            id="np"
            v-model="active.np">
          <label class="onoffswitch2-label" for="np">
            <span class="onoffswitch2-inner"></span>
            <span class="onoffswitch2-switch"></span>
          </label>
        </div>
      </div>
    </div>

    <div class="form-group row">
      <div class="col-sm-4 col-sm-offset-2">
        <LoaderButton @click="onClick">
          {{ $t('save') }}
        </LoaderButton>
      </div>
    </div>

    <div class="row mt-3 mb-3" v-if="$route.params.id">
      <div class="col-lg-12 text-center">
        <h3>Histórico de Movimentação</h3>
      </div>
    </div>

    <div class="row" v-if="$route.params.id">
      <div class="col-lg-12">
        <BootstrapTable
          id="table"
          ref="table"
          class="bg-white"
          :columns="columns"
          :data="activehistory"
          :options="options"
        />
      </div>
    </div>

    <!-- MODAL LOAD LINKED -->
  <div
    ref='modalShowLinked'
    id="modalShowLinked"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="modalShowLinked"
    aria-hidden="true"
  >
    <div class="modal modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">

        <div class="modal-header">
          <h5 class="modal-title" id="modalShowLinkedLabel">Atenção!</h5>
        </div>

        <div class="modal-body">
          <h3 id="message"></h3>

          <h4 class="mt-4">Deseja continuar?</h4>
        </div>

        <div class="col-12 text-right modal-footer">
          <b-button
            class="mt-3"
            id='closeModal'
            data-dismiss="modal"
          >
            {{ $t('no') }}
          </b-button>

          <b-button
            class="mt-3"
            variant="primary"
            @click='onClick(undefined, undefined, true)'
          >
            {{ $t('yes') }}
          </b-button>
        </div>
      </div>
    </div>
  </div>

  </form>

</template>

<script>
import { mapState, mapActions } from 'vuex'
import LoaderButton from '@/components/button/LoaderButton'
import BootstrapTable from 'bootstrap-table/dist/bootstrap-table-vue.esm.js'
import Combobox from '@/components/shared/ComboBox'
import location from '@/config/locations'
import moment from 'moment'

export default {
  name: 'ActiveForm',
  components: {
    LoaderButton,
    BootstrapTable,
    Combobox
  },

  data () {
    return {
      locations: location,
      validateGarage: '',
      validateGenerateSerial: '',
      validateAmountItems: '',
      isEdit: false,
      columns: [
        {
          title: this.$t('active'),
          field: 'model',
          formatter: value => {
            return value
              ? `${value.activeType.name} / ${value.name}`
              : '-'
          }
        },
        {
          title: this.$t('serial'),
          field: 'active',
          formatter: value => {
            return value
              ? value.serie
              : '-'
          }
        },
        {
          title: this.$t('from'),
          field: 'locationFrom',
          formatter: value => {
            return value
              ? value
              : '-'
          }
        },
        {
          title: this.$t('to'),
          field: 'locationTo',
          formatter: value => {
            return value
              ? value
              : '-'
          }
        },
        {
          title: this.$t('action'),
          field: 'action',
        },
        {
          title: this.$t('garage_accredited'),
          field: 'garageAccredited',
          formatter: value => {
            return value
              ? value.fantasyName
              : '-'
          }
        },
        {
          title: this.$t('user'),
          field: 'user',
          formatter: value => {
            return value
              ? value.name
              : '-'
          }
        },
        {
          title: this.$t('movement'),
          field: 'createdAt',
          formatter: value => {
            return moment(value).format('DD/MM/YYYY HH:mm:ss')
          }
        }
      ],
      options: {
        locale: 'pt-BR',
        exportOptions: { fileName: 'movimentação_de_ativo' }
      },
      lastSerial: undefined,
      activeStatus: [],
      legend1: {
        show: false,
        field: ''
      },
      legend2: {
        show: false,
        field: ''
      },
      legend3: {
        show: false,
        field: ''
      },
    }
  },

  props: {
    active: {
      type: Object,
      default: () => ({
        model           : undefined,
        serie           : '',
        activeType      : undefined,
        isActive        : true,
        location        : '',
        garageAccredited: null,
        purchaseDate    : '',
        purchaseValue   : 0,
        warrantyDate    : '',
        obs             : '',
        registerType    : 'INDIVIDUAL',
        amountItems     : 1,
        prefix          : '',
        generateSerial  : 'AUTO',
        from            : undefined,
        until           : undefined,
        status          : undefined,
        fieldExtra1     : undefined,
        fieldExtra2     : undefined,
        fieldExtra3     : undefined,
        np              : false
      })
    }
  },

  computed: {
    ...mapState({
      activestypes: state => state.activestype.all,
      models: state => state.model.all,
      garages: state => state.garageaccredited.all,
      activehistory: state => state.active.activesMovementReport,
      activestatus: state => state.activestatus.all
    })
  },

  watch: {
    'active.location': function (value) {
      if (value === 'OFICINA CREDENCIADA') {
        this.validateGarage = 'required'
      } else {
        this.validateGarage = ''
        this.active.garageAccredited = null
      }
    },

    'active.activeType': async function(value) {
      if (!value) {
        this.legend1.show = false
        this.legend2.show = false
        this.legend3.show = false
        this.active.status = undefined
        this.active.location = ''
        return this.active.model = undefined
      }

      if (this.active.registerType === 'BATCH') {
        const active = this.activestypes.filter(active => active.id === value)

        if (active.length > 0) {
          this.active.prefix = active[0].prefix
          this.lastSerial = active[0].lastSerialRegistered
          this.active.from = this.lastSerial + 1
        } else {
          this.active.prefix = ''
          this.lastSerial = undefined
        }
      }

      this.active.model = undefined

      this.verifyExtraField()

      const [locationAndStatus] = this.activestypes.filter(activeType => activeType.id === value)

      this.active.location = locationAndStatus.location
      this.active.status   = locationAndStatus.status

      const { dispatch } = this.$store

      value
        ? await dispatch('model/fetchFiltered', { activeType: value, activeForm: true })
        : await dispatch('model/fetchAll')
    },

    'active.registerType': function(value) {
      if (value === 'BATCH') {
        this.active.serie = 0
        this.validateGenerateSerial = 'required'
        this.validateAmountItems = 'required'

        if (this.active.activeType) {
          const active = this.activestypes.filter(active => active.id === this.active.activeType)

          if (active.length > 0) {
            this.active.prefix = active[0].prefix
            this.lastSerial = active[0].lastSerialRegistered
            this.active.from = this.lastSerial + 1
          } else {
            this.active.prefix = ''
            this.lastSerial = undefined
          }
        }

      } else {
        this.validateGenerateSerial = ''
        this.validateAmountItems = ''
        this.active.serie = undefined
        this.active.prefix = ''
      }
    },

    'active.amountItems': function(value) {
      const {
        from,
        until
      } = this.active

      const result = ((from * 1) + (value * 1)) - 1

      this.active.until = result < until
        ? from
        : result
    },

    'active.generateSerial': function(value) {
      this.active.from = this.lastSerial + 1
    },

    'active.from': function(value) {
      const {
        amountItems,
        from
      } = this.active

      const result = ((amountItems * 1) + (value * 1)) - 1

      this.active.until = result < until
        ? from
        : result
    }
  },

  methods: {
    ...mapActions('active', [
      'create',
      'edit',
      'cleanState'
    ]),

    async onClick (evtClick, doneFn, npConfirmed = false) {
      $('#modalShowLinked').modal('hide')

      const isValid = await this.$validator.validateAll()
      if (!isValid) {
        const err = new Error(this.$t('invalid_form_fields'))
        this.$store.dispatch('notify/error', err)
        return
      }

      const {
        id,
        amountItems,
        model,
        purchaseValue,
        status,
        np,
        linked
      } = this.active

      const { dispatch } = this.$store

      if (amountItems * 1 === 0) {
        const message = 'Quantidade de itens deve ser maior que 0'
        return dispatch('notify/error', { message })
      }

      if (typeof model === 'object') {
        this.active.model = model.id
      }

      if (!purchaseValue) {
        this.active.purchaseValue = 0
      }

      if (typeof status === 'object') {
        this.active.status = status.id
      }

      if (id && np && linked && !npConfirmed) {
        $('#message').text(`SIMCARD está vinculado ao RASTREADOR ${linked.serie}`)

        return $('#modalShowLinked').modal('show')
      }

      setTimeout(async () => {
        dispatch('overlay/show', true)

        const result = id
          ? await this.edit({ id, data: this.active })
          : await this.create(this.active)

        dispatch('overlay/show', false)

        if (result) {
          return this.$router.push({ name: 'listactives' })
        }
      }, 1000)

    },

    verifyExtraField() {
      const [activeType] = this.activestypes.filter(activeType => activeType.id === this.active.activeType)

      const formatText = value => {
        return value[0] + value.slice(1).toLowerCase()
      }

      this.legend1 = {
        show: !!activeType.fieldLegend1,
        field: activeType.fieldLegend1 ? formatText(activeType.fieldLegend1) : ''
      }

      this.legend2 = {
        show: !!activeType.fieldLegend2,
        field: activeType.fieldLegend2 ? formatText(activeType.fieldLegend2) : ''
      }

      this.legend3 = {
        show: !!activeType.fieldLegend3,
        field: activeType.fieldLegend3 ? formatText(activeType.fieldLegend3) : ''
      }
    },

    upper(attr) {
      this.active[attr] = this.active[attr].toUpperCase()
    },
  },

  async mounted() {
    const { dispatch } = this.$store
    const { id } = this.$route.params
    const {
      purchaseDate,
      warrantyDate,
      activeType
    } = this.active

    dispatch('overlay/show', true)

    await dispatch('activestype/fetchAll')
    await dispatch('garageaccredited/fetchAll')
    await dispatch('activestatus/fetchAll')

    if (id) {
      this.isEdit = true

      this.active.purchaseDate = moment(purchaseDate).format('YYYY-MM-DD')
      this.active.warrantyDate = moment(warrantyDate).format('YYYY-MM-DD')

      this.verifyExtraField()

      await dispatch('active/activeMovementReport', { active: id })

      await dispatch('model/fetchFiltered', { activeType, activeForm: true })
      return dispatch('overlay/show', false)
    }

    this.activeStatus = this.activestatus
    await dispatch('model/fetchAll')

    return dispatch('overlay/show', false)
  },

  destroyed () {
    const { dispatch } = this.$store

    dispatch('garageaccredited/cleanState')
    dispatch('activestype/cleanState')
    dispatch('model/cleanState')
    dispatch('activestatus/cleanState')
    this.cleanState()
  }
}
</script>
